import {createMultiPathSVG, createStrokeSVG} from './TEMPLATE'

// tabler: pin (fill weight)
export const Pin_Filled_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M15.113 3.21l.094 .083l5.5 5.5a1 1 0 0 1 -1.175 1.59l-3.172 3.171l-1.424 3.797a1 1 0 0 1 -.158 .277l-.07 .08l-1.5 1.5a1 1 0 0 1 -1.32 .082l-.095 -.083l-2.793 -2.792l-3.793 3.792a1 1 0 0 1 -1.497 -1.32l.083 -.094l3.792 -3.793l-2.792 -2.793a1 1 0 0 1 -.083 -1.32l.083 -.094l1.5 -1.5a1 1 0 0 1 .258 -.187l.098 -.042l3.796 -1.425l3.171 -3.17a1 1 0 0 1 1.497 -1.26z',
  ],
  viewBox: '0 0 24 24',
})

// tabler: pin
export const Pin_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4',
    'M9 15l-4.5 4.5',
    'M14.5 4l5.5 5.5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
